import { useState } from 'react'
import { Center, Container, Group, Loader, SegmentedControl, Stack, Text, Title } from '@mantine/core'
import { useQuery } from '@tanstack/react-query'
import { fetchUpcomingBirthdays } from '../shared/api/project-crm'
import { AppLayout } from '../features/projects/app-shell'
import { BirthdayCard } from '../features/project-details/birthday-card'
import { useAuthStore } from '../features/auth/store'
import { GreetButton, GreetingTemplatesButton } from '../features/greetings/greet-controls'

/**
 * Глобальный дашборд «Ближайшие ДР» — все ДР, видимые пользователю (canSeeProject),
 * в окне N дней. Фильтр окна 7/30/90 дней.
 */
export function BirthdaysPage() {
  const { user } = useAuthStore()
  const canGreet = user?.permissions.includes('greetings.manage') ?? false
  const [windowDays, setWindowDays] = useState<string>('30')
  const { data, isLoading } = useQuery({
    queryKey: ['birthdays', windowDays],
    queryFn: () => fetchUpcomingBirthdays(parseInt(windowDays, 10)),
  })

  return (
    <AppLayout>
      <Container size="lg" py="md">
        <Group justify="space-between" mb="md">
          <div>
            <Text size="xs" c="grape.7" fw={700} tt="uppercase">
              CRM
            </Text>
            <Title order={2}>🎂 Ближайшие дни рождения</Title>
          </div>
          <Group gap="sm">
            {canGreet && <GreetingTemplatesButton />}
            <SegmentedControl
              value={windowDays}
              onChange={setWindowDays}
              data={[
                { value: '7', label: '7 дней' },
                { value: '30', label: '30 дней' },
                { value: '90', label: '90 дней' },
                { value: '365', label: 'Год' },
              ]}
            />
          </Group>
        </Group>

        {isLoading && (
          <Center mih={200}>
            <Loader />
          </Center>
        )}

        {data && data.length === 0 && (
          <Center mih={200}>
            <Text c="dimmed">
              В ближайшие {windowDays} дней дней рождения не найдено.
            </Text>
          </Center>
        )}

        {data && data.length > 0 && (
          <Stack gap="sm">
            <Text size="sm" c="dimmed">
              Всего {data.length} (сотрудники + контакты), отсортированы по близости.
            </Text>
            {data.map((b) => (
              <BirthdayCard
                key={`${b.subject_type}:${b.subject_id}`}
                item={b}
                showProject
                action={canGreet ? <GreetButton item={b} /> : undefined}
              />
            ))}
          </Stack>
        )}
      </Container>
    </AppLayout>
  )
}
